import { Icon } from './icons';
import { cn } from './ui';

export function Logo({ size = 46 }: { size?: number }) {
  return (
    <div
      className="grid place-items-center rounded-xl border border-border bg-gradient-to-br from-[#171b25] to-[#0d1016] shadow-[0_0_0_1px_rgba(62,200,255,.08),0_8px_30px_rgba(0,0,0,.5)]"
      style={{ width: size, height: size }}
    >
      <Icon.Radar className="text-accent" width={size * 0.52} height={size * 0.52} />
    </div>
  );
}

export function Wordmark({ className }: { className?: string }) {
  return (
    <span className={cn('font-display font-extrabold tracking-[-0.02em]', className)}>
      Sieve<span className="text-accent">Guard</span>
    </span>
  );
}

export function Brand({ subtitle }: { subtitle?: string }) {
  return (
    <div className="flex items-center gap-3.5">
      <Logo />
      <div>
        <Wordmark className="text-[30px] leading-none" />
        {subtitle && <p className="mt-1.5 max-w-[520px] text-[13.5px] text-muted">{subtitle}</p>}
      </div>
    </div>
  );
}
